<template>
  <BasePopup
    v-model:visible="visible"
    popup-class="award-code-popup"
    :mask-closable="true"
    :show-close-btn="true"
    :show-confirm-btn="false"
  >
    <!-- 标题图片 -->
    <div class="award-code-title"></div>

    <!-- 奖励信息 -->
    <div class="award-info">
      <!-- 奖励图片（带背景） -->
      <div class="award-icon-wrapper">
        <div :class="`award-icon award-icon-${currentAwardDetail.icon.replace('.png', '')}`"></div>
      </div>
      <!-- 奖励名称 -->
      <div class="award-name">{{ currentAwardDetail.name }}</div>
    </div>

    <!-- 兑换码区域 -->
    <div class="code-row">
      <div class="code-label">兌換碼：{{ currentAwardDetail.rewardValue }}</div>
      <div class="copy-btn" @click="copyCode">
        <!-- 复制成功 Toast -->
        <transition name="fade">
          <div v-if="showCopyToast" class="copy-toast">複製成功</div>
        </transition>
      </div>
    </div>

    <!-- 兑换按钮 -->
    <div class="exchange-btn" @click="goExchange"></div>
  </BasePopup>
</template>

<script setup>
import { computed, ref } from 'vue';
import BasePopup from './BasePopup.vue';
import { currentAwardDetail, virtualAwardDetailPopupState } from '@/hooks/useGetAward';

// 弹窗可见性
const visible = computed({
  get: () => virtualAwardDetailPopupState.value,
  set: (val) => virtualAwardDetailPopupState.value = val
});

// Toast 提示状态
const showCopyToast = ref(false);

// 复制兑换码
const copyCode = async () => {
  try {
    await navigator.clipboard.writeText(currentAwardDetail.rewardValue);
    showCopySuccess();
  } catch (error) {
    // 降级方案
    const textArea = document.createElement('textarea');
    textArea.value = currentAwardDetail.rewardValue;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      showCopySuccess();
    } catch (err) {
      console.error('复制失败:', err);
    }
    document.body.removeChild(textArea);
  }
};

// 显示复制成功提示
const showCopySuccess = () => {
  showCopyToast.value = true;
  setTimeout(() => {
    showCopyToast.value = false;
  }, 1500);
};

// 前往兑换
const goExchange = async () => {
  // 先复制兑换码
  await copyCode();

  // 跳转到兑换页面
  const link = 'https://gevents.gnjoy.hk/globalexchange/index.html?gameId=386';
  const fullLink = window.globalGetGotoLink?.({ link }) || link;
  window.open(fullLink, '_blank');
};
</script>

